import React, { Component } from 'react';
import { Link } from 'react-router'

import {} from './Sidebar.css';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
        
        this.state = {
            loaded: true
        };
    
    }
    render() {
        if (this.state.loaded) {
            return (
                <div className="Sidebar-container">
                    <img className="Sidepanel-structure" src="/structure.png" alt="The structure of g-C3N4" />
                    <p className="Sidebar-link-title">Site Content</p>
                    <ul className="Sidebar-sitelinks">
                        <li className="Sidebar-sitelink"><Link to="/" > Front Page </Link></li>
                        <li className="Sidebar-sitelink"><Link to="/news"> News </Link></li>
                        <li className="Sidebar-sitelink"><Link to="/technical"> General Information</Link></li>
                        <li className="Sidebar-sitelink"><Link to="/research"> Research </Link></li>
                        <li className="Sidebar-sitelink"><Link to="/opensource"> Open Source </Link></li>
                        <li className="Sidebar-sitelink"><Link to="/p/1"> Blog </Link></li>
                        <li className="Sidebar-sitelink"><Link to="/about"> About </Link></li>
                    </ul>
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js